import React from 'react';
import { Redirect } from 'react-router-dom';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { ConnectSuccessPage } from '@wix/my-domains-shared-components/@connect-success-page';
import { useQueryParams } from '../../hooks/useQueryParams';
import { isConnectSuccessVerified } from './connectSuccessVerification';
export const ConnectSuccessRoute = () => {
  const _useQueryParams = useQueryParams(),
    getQueryParam = _useQueryParams.getQueryParam;
  const siteDomain = getQueryParam('siteDomain') ?? '';
  const siteName = getQueryParam('siteName') ?? '';
  const siteId = getQueryParam('siteId') ?? undefined;
  const variant = getQueryParam('variant') ?? 'connected';

  // Nothing to verify against without both — skip the request and bounce.
  if (!siteDomain || !siteId) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(ConnectSuccessContent, {
    siteDomain: siteDomain,
    siteName: siteName,
    siteId: siteId,
    variant: variant
  }));
};
const ConnectSuccessContent = _ref => {
  let siteDomain = _ref.siteDomain,
    siteName = _ref.siteName,
    siteId = _ref.siteId,
    variant = _ref.variant;
  const userDomainState = DomainsApiClient.hooks.useUserDomain({
    domain: siteDomain
  }, true, {
    useErrorBoundary: false
  });
  if (userDomainState.isLoading) {
    return null;
  }
  const verified = userDomainState.isError || isConnectSuccessVerified({
    siteId,
    userDomain: userDomainState.data
  });
  if (!verified) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  return /*#__PURE__*/React.createElement(ConnectSuccessPage, {
    siteDomain: siteDomain,
    siteName: siteName,
    siteId: siteId,
    variant: variant
  });
};
//# sourceMappingURL=ConnectSuccessRoute.js.map